import { useState } from 'react';
import { useParseQRClienteMutation } from '../services/facturacionApi';
import { ParsedClienteDataDto } from '../types/facturacion';
import { getErrorMessage } from '../utils/errorHelpers';

export const useQRScanner = () => {
  const [isScanning, setIsScanning] = useState(false);
  const [scanResult, setScanResult] = useState<string | null>(null);
  const [parsedData, setParsedData] = useState<ParsedClienteDataDto | null>(null);
  const [error, setError] = useState<string | null>(null);

  const [parseQR, { isLoading: parsing }] = useParseQRClienteMutation();

  const handleScan = async (qrContent: string): Promise<ParsedClienteDataDto | null> => {
    try {
      setError(null);
      setScanResult(qrContent);

      const result = await parseQR({ qrContent }).unwrap();
      setParsedData(result);
      return result;
    } catch (err) {
      const errorMsg = getErrorMessage(err, 'Error al procesar el código QR');
      setError(errorMsg);
      return null;
    }
  };

  const resetScanner = () => {
    setIsScanning(false);
    setScanResult(null);
    setParsedData(null);
    setError(null);
  };

  return {
    isScanning,
    setIsScanning,
    scanResult,
    parsedData,
    error,
    parsing,
    handleScan,
    resetScanner,
  };
};
